export default [
    {
        value: null,
        label: "Ikke spesifisert",
    },
    {
        value: "",
        label: "Ikke spesifisert",
    },
    {
        value: "unspecified",
        label: "Ikke spesifisert",
    },
    {
        value: "approved",
        label: "Godkjent",
        filterDefault: true
    },

    {
        value: "rejected",
        label: "Avslått",
        filterDefault: true
    },

    {
        value: "n/a",
        label: "Ikke relevant",
        filterDefault: true
    },

]


